export default function mailProtect() {
  const links = document.querySelectorAll('a');
  links.forEach((item) => {
    if (item.getAttribute('data-mailto-token') != null) {
      // eslint-disable-next-line no-param-reassign
      item.innerHTML = item.innerHTML.replace('@~@', '@');
      if (!item.classList.contains('mail-button')) {
        item.setAttribute('href', `mailto:${item.innerHTML}`);
      }
    }
  });
}
